<template>
    <el-dialog
        :visible.sync="viewDetails"
        :close-on-click-modal="true"
        width="95%"
        top="0"
        custom-class="customClass location-details"
        :lock-scroll="true"
        :before-close="closeModal"
    >
        <el-row :gutter="20">
            <el-col :span="24" class="text-left px-4">

            </el-col>
        </el-row>
        <el-row :gutter="20" class="mb-4">
            <el-col :span="24">
                <el-card>
                    <div class="text-left mb-4">
                        <el-button size="small" class="submit-btn" icon="el-icon-back" @click="closeModal">Back</el-button>
                    </div>
                    <task-dashboard-filter
                        :outlet-lists="outletLists"
                        :calendar-type-list="calendarTypeList"
                        :task-intermediate-categories="taskIntermediateCategories"
                        :audit-intermediate-categories="auditIntermediateCategories"
                        :initial-from-date="fromDate"
                        :initial-to-date="toDate"
                        :dashboard-tab="dashboardTab"
                        :selected-type="selectedType"
                        :selected-intermediate-category="intermediateCategory"
                        :select-outlet="outlet"
                        @changedSelectedOutlet="changedSelectedOutlet"
                        @changedDateTypeViewList="changedDateTypeView"
                        @changedFromDate="changedFromDate"
                        @changedToDate="changedToDate"
                        @changedSelectedAuditType="changedSelectedAuditType"
                    ></task-dashboard-filter>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-card>
                    <el-row  :gutter="20" style="margin-top: 10px">
						<el-col :span="8"></el-col>
						<el-col :span="6" class="text-center">
							<div class="grid-content">
								<h4>Performance - By {{ graphFilterBy == 'location' ? 'Location' : 'User' }}</h4>
							</div>
						</el-col>
						<el-col :span="4"></el-col>
						<el-col :span="6" class="text-right">
							<!-- <div v-if="dashboardTab == 'audit'" class="grid-content">
								<span>
									<span class="grade-title">Grade</span>
									<span class="grade-text grade-a">A</span>
									<span class="grade-text grade-b">B</span>
									<span class="grade-text grade-c">C</span>
									<span class="grade-text grade-d">D</span>
									<span class="grade-text grade-fail">Fail</span>
								</span>
							</div> -->
						</el-col>
					</el-row>
                    <location-insights-dashboard-graph
						:graph-labels="graphLabels"
						:graph-colors="graphColors"
						:graph-values="graphValues" 
                        :selected-graph-value-type="selectedGraphValueType"
					></location-insights-dashboard-graph>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="20" class="mt-4 mb-2">
            <el-col :span="24" class="text-right">

            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-card>
                    <div class="text-right">
                        <el-input
                            v-model="searched_location"
                            size="mini"
                            :placeholder="'Search by ' + (graphFilterBy == 'location' ? 'location' : 'employee')"
                            style="max-width: 300px"
                            class="mb-2"
                        >
                            <i
                                slot="prefix"
                                class="el-input__icon el-icon-search"
                            ></i>
                        </el-input>
                        <el-button
                            class="btn submit-btn"
                            size="mini"
                            style="margin-left: 10px;"
                            :style="!filtered_list.length ? 'opacity: 0.6; cursor: not-allowed;' : ''"
                            :disabled="!filtered_list.length"
                            icon="el-icon-download"
                            @click="downloadLocationPerformanceDetails"
                        >Download Reports</el-button>
                    </div>
                    <table class="task-table">
                        <thead>
                            <tr>
                                <th>LOCATION ID</th>
                                <th v-if="graphFilterBy == 'user'">
                                    LOCATION
                                    <el-popover placement="right" trigger="click">
                                        <el-input v-model="search_location_for_task" size="mini" placeholder="Search Location"></el-input>
                                        <div style="max-height: 250px; overflow: auto; margin-top: 10px;">
                                        <el-checkbox-group v-model="selected_location_filter_for_task">
                                            <el-checkbox
                                            v-for="(location, index) in tableData.map(el => el.outlet_name).filter((value, index, self) => distinct(value, index, self)).filter(data => !search_location_for_task || data.toLowerCase().includes(search_location_for_task.toLowerCase()))"
                                            :key="index" class="mb-2 checkbox-lable" :label="location" style="display: block"></el-checkbox>
                                        </el-checkbox-group>
                                        </div>
                                        <div class="flex justify-between mt-4">
                                        <span class="text-xs cursor-pointer primary-theme-color"
                                            @click="selectAllAuditReportsLocations()">Select all</span>
                                        <span class="text-xs cursor-pointer" @click="resetSelectedAuditReportsLocations()">Reset</span>
                                        </div>
                                        <span slot="reference">
                                        <img src="../../../../../../../src/assets/images/filter-icon.png" width="9" class="cursor-pointer" />
                                        </span>
                                    </el-popover>
                                </th>
                                <th v-if="graphFilterBy == 'user'">EMPLOYEE ID</th>
                                <th>
                                    {{ graphFilterBy == 'location' ? 'LOCATION' : 'EMPLOYEE' }}
                                    <el-popover placement="right" trigger="click">
                                        <el-input v-model="search_name_for_task" size="mini" :placeholder="'Search ' + (graphFilterBy == 'location' ? 'Location' : 'Employee')"></el-input>
                                        <div style="max-height: 250px; overflow: auto; margin-top: 10px;">
                                        <el-checkbox-group v-model="selected_name_filter_for_task">
                                            <el-checkbox
                                            v-for="(location, index) in tableData.map(el => el.name).filter((value, index, self) => distinct(value, index, self)).filter(data => !search_name_for_task || data.toLowerCase().includes(search_name_for_task.toLowerCase()))"
                                            :key="index" class="mb-2 checkbox-lable" :label="location" style="display: block"></el-checkbox>
                                        </el-checkbox-group>
                                        </div>
                                        <div class="flex justify-between mt-4">
                                        <span class="text-xs cursor-pointer primary-theme-color"
                                            @click="selectAllAuditReportsNames()">Select all</span>
                                        <span class="text-xs cursor-pointer" @click="resetSelectedAuditReportsNames()">Reset</span>
                                        </div>
                                        <span slot="reference">
                                        <img src="../../../../../../../src/assets/images/filter-icon.png" width="9" class="cursor-pointer" />
                                        </span>
                                    </el-popover>
                                </th>
                                <th v-if="graphFilterBy == 'user'">
                                    DESIGNATION
                                    <el-popover placement="right" trigger="click">
                                        <el-input v-model="searched_designation_name" size="mini" placeholder="Search Designation"></el-input>
                                        <div style="max-height: 250px; overflow: auto; margin-top: 10px;">
                                        <el-checkbox-group v-model="selected_designations_for_audit">
                                            <el-checkbox
                                            v-for="(grade, index) in audit_designation_list.filter(data => !searched_designation_name || data.toLowerCase().includes(searched_designation_name.toLowerCase()))"
                                            :key="index" class="mb-2 checkbox-lable" :label="grade" style="display: block"></el-checkbox>
                                        </el-checkbox-group>
                                        </div>
                                        <div class="flex justify-between mt-4">
                                        <span class="text-xs cursor-pointer primary-theme-color"
                                            @click="selected_designations_for_audit = [...audit_designation_list]">Select all</span>
                                        <span class="text-xs cursor-pointer" @click="selected_designations_for_audit = []">Reset</span>
                                        </div>
                                        <span slot="reference">
                                        <img src="../../../../../../../src/assets/images/filter-icon.png" width="9" class="cursor-pointer" />
                                        </span>
                                    </el-popover>
                                </th>
                                <th>
                                    REGION
                                    <el-popover placement="right" trigger="click">
                                        <el-input v-model="search_region_for_task" size="mini" placeholder="Search Region"></el-input>
                                        <div style="max-height: 250px; overflow: auto; margin-top: 10px;">
                                        <el-checkbox-group v-model="selected_region_filter_for_task">
                                            <el-checkbox
                                            v-for="(location, index) in tableData.map(el => el.region_name).filter((value, index, self) => distinct(value, index, self)).filter(data => !search_region_for_task || data.toLowerCase().includes(search_region_for_task.toLowerCase()))"
                                            :key="index" class="mb-2 checkbox-lable" :label="location" style="display: block"></el-checkbox>
                                        </el-checkbox-group>
                                        </div>
                                        <div class="flex justify-between mt-4">
                                        <span class="text-xs cursor-pointer primary-theme-color"
                                            @click="selectAllAuditReportsRegions()">Select all</span>
                                        <span class="text-xs cursor-pointer" @click="resetSelectedAuditReportsRegions()">Reset</span>
                                        </div>
                                        <span slot="reference">
                                        <img src="../../../../../../../src/assets/images/filter-icon.png" width="9" class="cursor-pointer" />
                                        </span>
                                    </el-popover>
                                </th>
                                <th>
                                    AREA LEAD
                                    <el-popover placement="right" trigger="click">
                                        <el-input v-model="search_sub_region_for_task" size="mini" placeholder="Search Area Lead"></el-input>
                                        <div style="max-height: 250px; overflow: auto; margin-top: 10px;">
                                        <el-checkbox-group v-model="selected_sub_region_filter_for_task">
                                            <el-checkbox
                                            v-for="(location, index) in tableData.map(el => el.subregion_name).filter((value, index, self) => distinct(value, index, self)).filter(data => !search_sub_region_for_task || data.toLowerCase().includes(search_sub_region_for_task.toLowerCase()))"
                                            :key="index" class="mb-2 checkbox-lable" :label="location" style="display: block"></el-checkbox>
                                        </el-checkbox-group>
                                        </div>
                                        <div class="flex justify-between mt-4">
                                        <span class="text-xs cursor-pointer primary-theme-color"
                                            @click="selectAllAuditReportsSubRegions()">Select all</span>
                                        <span class="text-xs cursor-pointer" @click="resetSelectedAuditReportsSubRegions()">Reset</span>
                                        </div>
                                        <span slot="reference">
                                        <img src="../../../../../../../src/assets/images/filter-icon.png" width="9" class="cursor-pointer" />
                                        </span>
                                    </el-popover>
                                </th>
                                <!-- Hidden Temporarily (Do not delete) -->
                                <!-- <th v-if="dashboardTab == 'audit' && graphFilterBy == 'location'">
                                    GRADE
                                    <el-popover placement="right" trigger="click">
                                        <el-input v-model="searched_grade_name" size="mini" placeholder="Search Grade"></el-input>
                                        <div style="max-height: 250px; overflow: auto; margin-top: 10px;">
                                        <el-checkbox-group v-model="selected_grades_for_audit">
                                            <el-checkbox
                                            v-for="(grade, index) in audit_grade_list.filter(data => !searched_grade_name || data.toLowerCase().includes(searched_grade_name.toLowerCase()))"
                                            :key="index" class="mb-2 checkbox-lable" :label="grade" style="display: block"></el-checkbox>
                                        </el-checkbox-group>
                                        </div>
                                        <div class="flex justify-between mt-4">
                                        <span class="text-xs cursor-pointer primary-theme-color"
                                            @click="selected_grades_for_audit = [...audit_grade_list]">Select all</span>
                                        <span class="text-xs cursor-pointer" @click="selected_grades_for_audit = []">Reset</span>
                                        </div>
                                        <span slot="reference">
                                        <img src="../../../../../../../src/assets/images/filter-icon.png" width="9" class="cursor-pointer" />
                                        </span>
                                    </el-popover>
                                </th> -->
                                <th v-if="dashboardTab == 'audit'">
                                    POINTS AVAILABLE
                                    <span slot="reference" class="cursor-pointer">
                                        <i
                                            v-if="sort_by_points_available == 'desc'"
                                            style="font-size: 12px"
                                            class="el-icon-caret-top"
                                            @click="
                                            sort_by_points_available = 'asc';
                                            sort_by_audits_completion_percentage = '';
                                            sort_by_audits = '';
                                            sort_by_audits_completed = '';
                                            sort_by_audits_incomplete = '';
                                            sort_by_points_achieved = '';
                                            sort_by_score_percentage = '';
                                            sort_by_audit_grade = '';
                                            sort_by_task_total = '';
                                            sort_by_task_completed = '';
                                            sort_by_task_incomplete = '';
                                            sort_by_task_completion_percentage = '';
                                            sort_by_audit_completion_percentage = '';
                                            "
                                        ></i>
                                        <i
                                            v-if="sort_by_points_available == '' || sort_by_points_available == 'asc'"
                                            style="font-size: 12px"
                                            class="el-icon-caret-bottom"
                                            @click="
                                            sort_by_points_available = 'desc';
                                            sort_by_audits_completion_percentage = '';
                                            sort_by_audits = '';
                                            sort_by_audits_completed = '';
                                            sort_by_audits_incomplete = '';
                                            sort_by_points_achieved = '';
                                            sort_by_score_percentage = '';
                                            sort_by_audit_grade = '';
                                            sort_by_task_total = '';
                                            sort_by_task_completed = '';
                                            sort_by_task_incomplete = '';
                                            sort_by_task_completion_percentage = '';
                                            sort_by_audit_completion_percentage = '';
                                            "
                                        ></i>
                                    </span>
                                </th>
                                <th v-if="dashboardTab == 'audit'">
                                    POINTS ACHIEVED
                                    <span slot="reference" class="cursor-pointer">
                                        <i
                                            v-if="sort_by_points_achieved == 'desc'"
                                            style="font-size: 12px"
                                            class="el-icon-caret-top"
                                            @click="
                                            sort_by_points_achieved = 'asc';
                                            sort_by_points_available = '';
                                            sort_by_audits_completion_percentage = '';
                                            sort_by_audits = '';
                                            sort_by_audits_completed = '';
                                            sort_by_audits_incomplete = '';
                                            sort_by_score_percentage = '';
                                            sort_by_audit_grade = '';
                                            sort_by_task_total = '';
                                            sort_by_task_completed = '';
                                            sort_by_task_incomplete = '';
                                            sort_by_task_completion_percentage = '';
                                            sort_by_audit_completion_percentage = '';
                                            "
                                        ></i>
                                        <i
                                            v-if="sort_by_points_achieved == '' || sort_by_points_achieved == 'asc'"
                                            style="font-size: 12px"
                                            class="el-icon-caret-bottom"
                                            @click="
                                            sort_by_points_achieved = 'desc';
                                            sort_by_points_available = '';
                                            sort_by_audits_completion_percentage = '';
                                            sort_by_audits = '';
                                            sort_by_audits_completed = '';
                                            sort_by_audits_incomplete = '';
                                            sort_by_score_percentage = '';
                                            sort_by_audit_grade = '';
                                            sort_by_task_total = '';
                                            sort_by_task_completed = '';
                                            sort_by_task_incomplete = '';
                                            sort_by_task_completion_percentage = '';
                                            sort_by_audit_completion_percentage = '';
                                            "
                                        ></i>
                                    </span>
                                </th>
                                <th v-if="dashboardTab == 'other'">
                                    TOTAL TASKS
                                    <span slot="reference" class="cursor-pointer">
                                        <i
                                            v-if="sort_by_task_total == 'desc'"
                                            class="el-icon-caret-top"
                                            style="font-size: 12px"
                                            @click="
                                            sort_by_audits_completed = '';
                                            sort_by_audits = '';
                                            sort_by_audits_incomplete = '';
                                            sort_by_audits_completion_percentage = '';
                                            sort_by_points_available = '';
                                            sort_by_points_achieved = '';
                                            sort_by_score_percentage = '';
                                            sort_by_audit_grade = '';
                                            sort_by_task_total = 'asc';
                                            sort_by_task_completed = '';
                                            sort_by_task_incomplete = '';
                                            sort_by_task_completion_percentage = '';
                                            sort_by_audit_completion_percentage = '';
                                            "
                                        ></i>
                                        <i
                                            v-if="sort_by_task_total == '' || sort_by_task_total == 'asc'"
                                            style="font-size: 12px"
                                            class="el-icon-caret-bottom"
                                            @click="
                                            sort_by_audits_completed = '';
                                            sort_by_audits = '';
                                            sort_by_audits_incomplete = '';
                                            sort_by_audits_completion_percentage = '';
                                            sort_by_points_available = '';
                                            sort_by_points_achieved = '';
                                            sort_by_score_percentage = '';
                                            sort_by_audit_grade = '';
                                            sort_by_task_total = 'desc';
                                            sort_by_task_completed = '';
                                            sort_by_task_incomplete = '';
                                            sort_by_task_completion_percentage = '';
                                            sort_by_audit_completion_percentage = '';
                                            "
                                        ></i>
                                    </span>
                                </th>
                                <th v-if="dashboardTab == 'other'">
                                    COMPLETED
                                    <span slot="reference" class="cursor-pointer">
                                        <i
                                            v-if="sort_by_task_completed == 'desc'"
                                            class="el-icon-caret-top"
                                            style="font-size: 12px"
                                            @click="
                                            sort_by_audits_completed = '';
                                            sort_by_audits = '';
                                            sort_by_audits_incomplete = '';
                                            sort_by_audits_completion_percentage = '';
                                            sort_by_points_available = '';
                                            sort_by_points_achieved = '';
                                            sort_by_score_percentage = '';
                                            sort_by_audit_grade = '';
                                            sort_by_task_total = '';
                                            sort_by_task_completed = 'asc';
                                            sort_by_task_incomplete = '';
                                            sort_by_task_completion_percentage = '';
                                            sort_by_audit_completion_percentage = '';
                                            "
                                        ></i>
                                        <i
                                            v-if="sort_by_task_completed == '' || sort_by_task_completed == 'asc'"
                                            style="font-size: 12px"
                                            class="el-icon-caret-bottom"
                                            @click="
                                            sort_by_audits_completed = '';
                                            sort_by_audits = '';
                                            sort_by_audits_incomplete = '';
                                            sort_by_audits_completion_percentage = '';
                                            sort_by_points_available = '';
                                            sort_by_points_achieved = '';
                                            sort_by_score_percentage = '';
                                            sort_by_audit_grade = '';
                                            sort_by_task_total = '';
                                            sort_by_task_completed = 'desc';
                                            sort_by_task_incomplete = '';
                                            sort_by_task_completion_percentage = '';
                                            sort_by_audit_completion_percentage = '';
                                            "
                                        ></i>
                                    </span>
                                </th>
                                <th v-if="dashboardTab == 'other'">
                                    INCOMPLETE
                                    <span slot="reference" class="cursor-pointer">
                                        <i
                                            v-if="sort_by_task_incomplete == 'desc'"
                                            style="font-size: 12px"
                                            class="el-icon-caret-top"
                                            @click="
                                            sort_by_audits_incomplete = '';
                                            sort_by_audits = '';
                                            sort_by_audits_completed = '';
                                            sort_by_audits_completion_percentage = '';
                                            sort_by_points_available = '';
                                            sort_by_points_achieved = '';
                                            sort_by_score_percentage = '';
                                            sort_by_audit_grade = '';
                                            sort_by_task_total = '';
                                            sort_by_task_completed = '';
                                            sort_by_task_incomplete = 'asc';
                                            sort_by_task_completion_percentage = '';
                                            sort_by_audit_completion_percentage = '';
                                            "
                                        ></i>
                                        <i
                                            v-if="sort_by_task_incomplete == '' || sort_by_task_incomplete == 'asc'"
                                            style="font-size: 12px"
                                            class="el-icon-caret-bottom"
                                            @click="
                                            sort_by_audits_incomplete = '';
                                            sort_by_audits = '';
                                            sort_by_audits_completed = '';
                                            sort_by_audits_completion_percentage = '';
                                            sort_by_points_available = '';
                                            sort_by_points_achieved = '';
                                            sort_by_score_percentage = '';
                                            sort_by_audit_grade = '';
                                            sort_by_task_total = '';
                                            sort_by_task_completed = '';
                                            sort_by_task_incomplete = 'desc';
                                            sort_by_task_completion_percentage = '';
                                            sort_by_audit_completion_percentage = '';
                                            "
                                        ></i>
                                    </span>
                                </th>
                                <th>
                                    {{ dashboardTab == 'other' ? 'COMPLETION' : 'SCORE' }} %
                                    <span slot="reference" class="cursor-pointer">
                                        <template v-if="dashboardTab == 'audit' && graphFilterBy == 'location'">
                                            <i
                                                v-if="sort_by_audits_completion_percentage == 'desc'"
                                                style="font-size: 12px"
                                                class="el-icon-caret-top"
                                                @click="
                                                sort_by_audits_completion_percentage = 'asc';
                                                sort_by_audits = '';
                                                sort_by_audits_completed = '';
                                                sort_by_audits_incomplete = '';
                                                sort_by_points_available = '';
                                                sort_by_points_achieved = '';
                                                sort_by_score_percentage = '';
                                                sort_by_audit_grade = '';
                                                sort_by_task_total = '';
                                                sort_by_task_completed = '';
                                                sort_by_task_incomplete = '';
                                                sort_by_task_completion_percentage = '';
                                                sort_by_audit_completion_percentage = '';
                                                "
                                            ></i>
                                            <i
                                                v-if="sort_by_audits_completion_percentage == '' || sort_by_audits_completion_percentage == 'asc'"
                                                style="font-size: 12px"
                                                class="el-icon-caret-bottom"
                                                @click="
                                                sort_by_audits_completion_percentage = 'desc';
                                                sort_by_audits = '';
                                                sort_by_audits_completed = '';
                                                sort_by_audits_incomplete = '';
                                                sort_by_points_available = '';
                                                sort_by_points_achieved = '';
                                                sort_by_score_percentage = '';
                                                sort_by_audit_grade = '';
                                                sort_by_task_total = '';
                                                sort_by_task_completed = '';
                                                sort_by_task_incomplete = '';
                                                sort_by_task_completion_percentage = '';
                                                sort_by_audit_completion_percentage = '';
                                                "
                                            ></i>
                                        </template>
                                        <template v-else-if="dashboardTab == 'other'">
                                            <i
                                                v-if="sort_by_task_completion_percentage == 'desc'"
                                                style="font-size: 12px"
                                                class="el-icon-caret-top"
                                                @click="
                                                sort_by_audits_completion_percentage = '';
                                                sort_by_audits = '';
                                                sort_by_audits_completed = '';
                                                sort_by_audits_incomplete = '';
                                                sort_by_points_available = '';
                                                sort_by_points_achieved = '';
                                                sort_by_score_percentage = '';
                                                sort_by_audit_grade = '';
                                                sort_by_task_total = '';
                                                sort_by_task_completed = '';
                                                sort_by_task_incomplete = '';
                                                sort_by_audit_completion_percentage = '';
                                                sort_by_task_completion_percentage = 'asc';
                                                "
                                            ></i>
                                            <i
                                                v-if="sort_by_task_completion_percentage == '' || sort_by_task_completion_percentage == 'asc'"
                                                style="font-size: 12px"
                                                class="el-icon-caret-bottom"
                                                @click="
                                                sort_by_audits_completion_percentage = '';
                                                sort_by_audits = '';
                                                sort_by_audits_completed = '';
                                                sort_by_audits_incomplete = '';
                                                sort_by_points_available = '';
                                                sort_by_points_achieved = '';
                                                sort_by_score_percentage = '';
                                                sort_by_audit_grade = '';
                                                sort_by_task_total = '';
                                                sort_by_task_completed = '';
                                                sort_by_task_incomplete = '';
                                                sort_by_audit_completion_percentage = '';
                                                sort_by_task_completion_percentage = 'desc';
                                                "
                                            ></i>
                                        </template>
                                    </span>
                                </th>
                                <th v-if="dashboardTab == 'audit'">
                                    COMPLETION %
                                    <span slot="reference" class="cursor-pointer">
                                        <i
                                            v-if="sort_by_audit_completion_percentage == 'desc'"
                                            style="font-size: 12px"
                                            class="el-icon-caret-top"
                                            @click="
                                            sort_by_audits_incomplete = '';
                                            sort_by_audits = '';
                                            sort_by_audits_completed = '';
                                            sort_by_audits_completion_percentage = '';
                                            sort_by_points_available = '';
                                            sort_by_points_achieved = '';
                                            sort_by_score_percentage = '';
                                            sort_by_audit_grade = '';
                                            sort_by_task_total = '';
                                            sort_by_task_completed = '';
                                            sort_by_audit_completion_percentage = 'asc';
                                            sort_by_task_incomplete = '';
                                            sort_by_task_completion_percentage = '';
                                            "
                                        ></i>
                                        <i
                                            v-if="sort_by_audit_completion_percentage == '' || sort_by_audit_completion_percentage == 'asc'"
                                            style="font-size: 12px"
                                            class="el-icon-caret-bottom"
                                            @click="
                                            sort_by_audits_incomplete = '';
                                            sort_by_audits = '';
                                            sort_by_audits_completed = '';
                                            sort_by_audits_completion_percentage = '';
                                            sort_by_points_available = '';
                                            sort_by_points_achieved = '';
                                            sort_by_score_percentage = '';
                                            sort_by_audit_grade = '';
                                            sort_by_task_total = '';
                                            sort_by_task_completed = '';
                                            sort_by_audit_completion_percentage = 'desc';
                                            sort_by_task_incomplete = '';
                                            sort_by_task_completion_percentage = '';
                                            "
                                        ></i>
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody style="height: 300px; overflow-y: scroll;">
                            <template v-for="(item, index) in filtered_list">
                                <tr v-if="index >= startnumber - 1 && index < endnumber" :key="'location-performance-item-'+index">
                                    <td>{{ item.store_id }}</td>
                                    <td v-if="graphFilterBy == 'user'">{{ item.outlet_name }}</td>
                                    <td v-if="graphFilterBy == 'user'">{{ item.emp_id ? item.emp_id : '-' }}</td>
                                    <td>{{ item.name ? item.name : getOutletName }}</td>
                                    <td v-if="graphFilterBy == 'user'">
                                        {{ item.designation ? item.designation : '-' }}
                                    </td>
                                    <td>{{ item.region_name }}</td>
                                    <td>{{ item.subregion_name }}</td>
                                    <!-- Hidden Temporarily (Do not delete) -->
                                    <!-- <td v-if="dashboardTab == 'audit' && graphFilterBy == 'location'">{{ (item.grade || item.grade == 0) ? item.grade : '-' }}</td> -->
                                    <td v-if="dashboardTab == 'audit'">{{ item.total_yes_no_points }}</td>
                                    <td v-if="dashboardTab == 'audit'">{{ item.total_yes_no_points_achieved }}</td>
                                    <td v-if="dashboardTab == 'other'">{{ (item.total || item.total == 0) ? item.total : '-' }}</td>
                                    <td v-if="dashboardTab == 'other'">{{ (item.completed || item.completed == 0) ? item.completed : '-' }}</td>
                                    <td v-if="dashboardTab == 'other' && item.total">{{ item.total - item.completed }}</td>
                                    <td v-if="dashboardTab == 'other'">{{ item.completion_rate | fixed }}%</td>
                                    <td v-if="dashboardTab == 'audit'">{{ item.yes_no_points_percentage }}%</td>
                                    <td v-if="dashboardTab == 'audit'">{{ item.completion_rate }}%</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <el-row :gutter="20" class="mt-4">
                        <el-col :span="8" class="text-left">
                            <div><b>Showing</b> {{ startnumber }} to {{ endnumber }} of {{ filtered_list.length }} results</div>
                        </el-col>
                        <el-col :span="8" class="text-center">
                            <el-select v-model="perPage" name="per_page" placeholder="select per page" style="width: 90px !important;">
                                <el-option label="10" :value="10"></el-option>
                                <el-option label="25" :value="25"></el-option>
                                <el-option label="50" :value="50"></el-option>
                                <el-option label="100" :value="100"></el-option>
                            </el-select>
                            &nbsp;<b>per page</b>
                        </el-col>
                        <el-col :span="8" class="text-right">
                            <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="filtered_list.length"
                                :page-size="perPage"
                                :current-page.sync="currentPage"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                            ></el-pagination>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
    </el-dialog>
</template>

<script>
import exportFromJSON from 'export-from-json';
import { EventBus } from "../../../../../../eventBus";
import LocationInsightsDashboardGraph from './LocationInsightsDashboardGraph.vue';
import TaskDashboardFilter from '../../TaskComponents/TaskDashboardFilter.vue';
export default {
    name: "LocationPerformanceDetails",
    components: {
        LocationInsightsDashboardGraph,
        TaskDashboardFilter,
    },
    filters: {
        fixed(val) {
            if(Number(val) === val && val % 1 !== 0) {
                return val.toFixed(2);
            } else {
                return val;
            }
        }
    },
    props: {
        viewDetails: {
            type: Boolean,
            default: false
        },
        height: {
            type: Number,
            default: 400
        },
        graphFilterBy: {
            type: String,
            default: 'location'
        },
        dashboardTab: {
            type: String,
            default: 'audit'
        },
        tableData: {
            type: Array,
            default: () => []
        },
        outlet: {
            type: String,
            default: null
        },
        getOutletName: {
            type: String,
            default: null
        },
		fromDate: {
			type: String,
			default: "",
		},
		toDate: {
			type: String,
			default: "",
		},
        intermediateCategory: {
            type: String,
            required: false,
            default: ""
        },
		auditIntermediateCategories: {
			type: Array,
			required: false,
			default: () => []
		},
		taskIntermediateCategories: {
			type: Array,
			required: false,
			default: () => []
		},
        graphValues: {
            type: Array,
            required: true
        },
        graphColors: {
            type: Array,
            required: true
        },
        graphLabels: {
            type: Array,
            required: true
        },
		outletLists: {
            required: true,
            type: Array,
        },
        calendarTypeList: {
            required: true,
            type: Array
        },
        selectedType: {
            type: String,
            required: true,
        },
        selectedIntermediateCategory: {
            type: String,
            default: null
        },
        selectedGraphValueType: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            searched_location: "",
            sort_by_audits: "",
            sort_by_audits_completed: "",
            sort_by_audits_incomplete: "",
            sort_by_audits_completion_percentage: "",
            sort_by_points_available: "",
            sort_by_points_achieved: "",
            sort_by_score_percentage: "",
            sort_by_audit_grade: "",
            sort_by_audit_completion_percentage: "",
            sort_by_task_total: "",
            sort_by_task_completed: "",
            sort_by_task_incomplete: "",
            sort_by_task_completion_percentage: "",
            searched_grade_name: "",
            selected_grades_for_audit: [],
            searched_designation_name: "",
            selected_designations_for_audit: [],
            currentPage: 1,
            perPage: 10,
            search_location_for_task: "",
            selected_location_filter_for_task: [],
            search_name_for_task: "",
            selected_name_filter_for_task: [],
            search_region_for_task: "",
            selected_region_filter_for_task: [],
            search_sub_region_for_task: "",
            selected_sub_region_filter_for_task: [],
        };
    },
    computed: {
        currentIndex() {
            let index = 0;

            let total_records = this.filtered_list.length;

            let total_pages = (total_records / this.perPage);
            if(total_pages) {
                total_pages = total_pages.toFixed();
            }

            if(this.currentPage > 1) {
                index = this.currentPage - 1;
            }

            return index;
        },
        startnumber() {
            let start = (this.currentPage * this.perPage) - (this.perPage - 1);
            return start;
        },
        endnumber() {
            let end = Math.min(this.startnumber + this.perPage - 1, this.filtered_list.length);
            return end;
        },
        filtered_list() {
            let result = [...this.tableData];

            if(this.searched_location) {
                result = result.filter(el => el.name.toString().toLowerCase().startsWith(this.searched_location.toString().toLowerCase()))
            }

            // Location filter
            if(this.graphFilterBy == 'user') {
                if(this.selected_location_filter_for_task.length) {
                    result = result.filter(el => this.selected_location_filter_for_task.includes(el.outlet_name));
                }
            }

            if(this.selected_name_filter_for_task.length) {
                result = result.filter(el => this.selected_name_filter_for_task.includes(el.name));
            }

            // Region filter
            if(this.selected_region_filter_for_task.length) {
                result = result.filter(el => this.selected_region_filter_for_task.includes(el.region_name));
            }

            // Sub Region filter
            if(this.selected_sub_region_filter_for_task.length) {
                result = result.filter(el => this.selected_sub_region_filter_for_task.includes(el.subregion_name));
            }

            // Grade filter
            if(this.dashboardTab == 'audit' && this.selected_grades_for_audit.length) {
                result = result.filter(el => this.selected_grades_for_audit.includes(el.grade));
            }

            // Designation filter
            if(this.graphFilterBy == 'user' && this.selected_designations_for_audit.length) {
                result = result.filter(el => this.selected_designations_for_audit.includes(el.designation));
            }

            if(this.sort_by_audits) {
				if(this.sort_by_audits.toString().toLowerCase() == 'asc') {
					result.sort((a, b) => a.total_cycles - b.total_cycles);
				}

				if(this.sort_by_audits.toString().toLowerCase() == 'desc') {
					result.sort((a, b) => b.total_cycles - a.total_cycles);
				}
			}

            if(this.sort_by_audits_completed) {
				if(this.sort_by_audits_completed.toString().toLowerCase() == 'asc') {
					result.sort((a, b) => a.cycles_completed - b.cycles_completed);
				}

				if(this.sort_by_audits_completed.toString().toLowerCase() == 'desc') {
					result.sort((a, b) => b.cycles_completed - a.cycles_completed);
				}
			}

            if(this.sort_by_audits_incomplete) {
				if(this.sort_by_audits_incomplete.toString().toLowerCase() == 'asc') {
					result.sort((a, b) => (a.total_cycles - a.cycles_completed) - (b.total_cycles - b.cycles_completed));
				}

				if(this.sort_by_audits_incomplete.toString().toLowerCase() == 'desc') {
					result.sort((a, b) => (b.total_cycles - b.cycles_completed) - (a.total_cycles - a.cycles_completed));
				}
			}

            if(this.sort_by_audits_completion_percentage) {
				if(this.sort_by_audits_completion_percentage.toString().toLowerCase() == 'asc') {
                    if(this.graphFilterBy == 'location') {
                        result.sort((a, b) => a.cycle_completion_percentage - b.cycle_completion_percentage);
                    } else {
                        result.sort((a, b) => a.yes_no_points_percentage - b.yes_no_points_percentage);
                    }
				}

				if(this.sort_by_audits_completion_percentage.toString().toLowerCase() == 'desc') {
                    if(this.graphFilterBy == 'location') {
					    result.sort((a, b) => b.cycle_completion_percentage - a.cycle_completion_percentage);
                    } else {
                        result.sort((a, b) => b.yes_no_points_percentage - a.yes_no_points_percentage);
                    }
				}
			}

            if(this.sort_by_audit_completion_percentage && this.dashboardTab == 'audit') {
                let check = result.find(el => el.cycle_completion_percentage || el.cycle_completion_percentage == 0);
                if(check !== undefined && this.graphFilterBy == 'location') {
                    if(this.sort_by_audit_completion_percentage.toString().toLowerCase() == 'asc') {
                        result.sort((a, b) => a.cycle_completion_percentage - b.cycle_completion_percentage);
                    } else if(this.sort_by_audit_completion_percentage.toString().toLowerCase() == 'desc') {
                        result.sort((a, b) => b.cycle_completion_percentage - a.cycle_completion_percentage);
                    }
                } else if(check !== undefined && this.graphFilterBy == 'user') {
                    if(this.sort_by_audit_completion_percentage.toString().toLowerCase() == 'asc') {
                        result.sort((a, b) => a.completion_rate - b.completion_rate);
                    } else if(this.sort_by_audit_completion_percentage.toString().toLowerCase() == 'desc') {
                        result.sort((a, b) => b.completion_rate - a.completion_rate);
                    }
                }
			}

            if(this.sort_by_points_available) {
				if(this.sort_by_points_available.toString().toLowerCase() == 'asc') {
					result.sort((a, b) => a.total_yes_no_points - b.total_yes_no_points);
				}

				if(this.sort_by_points_available.toString().toLowerCase() == 'desc') {
					result.sort((a, b) => b.total_yes_no_points - a.total_yes_no_points);
				}
			}

            if(this.sort_by_points_achieved) {
				if(this.sort_by_points_achieved.toString().toLowerCase() == 'asc') {
					result.sort((a, b) => a.total_yes_no_points_achieved - b.total_yes_no_points_achieved);
				}

				if(this.sort_by_points_achieved.toString().toLowerCase() == 'desc') {
					result.sort((a, b) => b.total_yes_no_points_achieved - a.total_yes_no_points_achieved);
				}
			}

            if(this.sort_by_score_percentage) {
				if(this.sort_by_score_percentage.toString().toLowerCase() == 'asc') {
					result.sort((a, b) => a.yes_no_points_percentage - b.yes_no_points_percentage);
				}

				if(this.sort_by_score_percentage.toString().toLowerCase() == 'desc') {
					result.sort((a, b) => b.yes_no_points_percentage - a.yes_no_points_percentage);
				}
			}

            // Task sort filters
            if(this.sort_by_task_total) {
                if(this.sort_by_task_total == 'asc') {
                    result.sort((a, b) => a.total - b.total);
                } else if(this.sort_by_task_total == 'desc') {
                    result.sort((a, b) => b.total - a.total);
                }
            }

            if(this.sort_by_task_completed) {
                if(this.sort_by_task_completed == 'asc') {
                    result.sort((a, b) => a.completed - b.completed);
                } else if(this.sort_by_task_completed == 'desc') {
                    result.sort((a, b) => b.completed - a.completed);
                }
            }

            if(this.sort_by_task_incomplete) {
                if(this.sort_by_task_incomplete == 'asc') {
                    result.sort((a, b) => (a.total - a.completed) - (b.total - b.completed));
                } else if(this.sort_by_task_incomplete == 'desc') {
                    result.sort((a, b) => (b.total - b.completed) - (a.total - a.completed));
                }
            }

            if(this.sort_by_task_completion_percentage) {
                if(this.sort_by_task_completion_percentage == 'asc') {
                    result.sort((a, b) => a.completion_rate - b.completion_rate);
                } else if(this.sort_by_task_completion_percentage == 'desc') {
                    result.sort((a, b) => b.completion_rate - a.completion_rate);
                }
            }
            return result;
        },
        intermediateCategoryName() {
            let category_name = "";
            if(this.dashboardTab) {
                if(this.dashboardTab == 'audit') {
                    let check = this.auditIntermediateCategories.find(el => el.id == this.intermediateCategory);
                    if(check !== undefined) {
                        category_name = check.name.replace(/ /g, '_');
                    } else {
                        category_name = "All_Audits";
                    }
                } else {
                    let check = this.taskIntermediateCategories.find(el => el.id == this.intermediateCategory);
                    if(check !== undefined) {
                        category_name = check.name.replace(/ /g, '_');
                    }else {
                        category_name = "All_Tasks";
                    }
                }
            }
            return category_name;
        },
        audit_grade_list() {
            if(this.dashboardTab == 'audit') {
                let grade_list = [...new Set(this.tableData.filter(el => el.grade).map(el => el.grade))];
                return grade_list;
            } else {
                return [];
            }
        },
        audit_designation_list() {
            if(this.graphFilterBy == 'user') {
                let grade_list = [...new Set(this.tableData.filter(el => el.designation).map(el => el.designation))];
                return grade_list;
            } else {
                return [];
            }
        },
    },
    mounted() {
        const self = this;
        EventBus.$on('updateGraphWidth', function() {
            self.handleGraphSpace();
        });
    },
    updated() {
        this.handleGraphSpace();
    },
    methods: {
        changedSelectedOutlet(event) {
            this.$emit('changedSelectedOutlet', event);
        },
        changedDateTypeView(event) {
            this.$emit('changedDateTypeViewList', event);
        },
        changedFromDate(event) {
            this.$emit('changedFromDate', event);
        },
        changedToDate(event) {
            this.$emit('changedToDate', event)
        },
        changedSelectedAuditType(event) {
            this.$emit('changedSelectedAuditType', event);
        },
        selectAllAuditReportsLocations() {
            this.selected_location_filter_for_task = this.filtered_list.map(el => el.outlet_name);
        },
        resetSelectedAuditReportsLocations() {
            this.selected_location_filter_for_task = [];
        },
        selectAllAuditReportsNames() {
            this.selected_name_filter_for_task = this.filtered_list.map(el => el.name);
        },
        resetSelectedAuditReportsNames() {
            this.selected_name_filter_for_task = [];
        },
        handleGraphSpace() {
            const contentBody = document.getElementById('contentBody');
            if(contentBody) {
                contentBody.style.width = `100%`;
                const totalLabels = this.chartData.labels.length;
                if(totalLabels > 10 && contentBody) {
                    const oldWidth = contentBody.offsetWidth;
                    const newWidth = oldWidth + ((totalLabels - 10) * 40);
                    contentBody.style.width = `${newWidth}px`;
                }
            }
        },
        handleSizeChange(val) {
            // console.log(val);
        },
        handleCurrentChange(val) {
            // console.log(val);
        },
        closeModal() {
            this.$emit('closeLocationPerformanceDetails', true);
        },
        getAuditReportLocations() {
			const params = {
				"basics": "outlet",
				"include_dates": false,
				"start_date": this.from_date,
				"end_date": this.to_date,
				"filters": {
					"nameValuePairs": {
						"outlets": []
					}
				},
				"designation": null,
				"main_category": "audit"
			};
			if(this.outlet) {
				params.filters.outlets.push(this.outlet);
				params.filters.nameValuePairs.outlets.push(this.outlet);
			}
            let url = this.dashboardTab == 'audit' ? '/bk_task_assignment/report/?get_all=true' : '/task_assignment/report/?get_all=true';
            if(this.from_date && this.to_date) {
                serverAddr.post(url, params)
                .then(response => {
                    const responseData = JSON.parse(response.data);
                    this.auditReportsLocations = responseData.results;
                }).catch(error => {
                    console.error(error);
                });
            }
		},
        isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        },
        titleCase(str) {
            if(str) {
                let splitStr = str.toLowerCase().split(' ');
                for (let i = 0; i < splitStr.length; i++) {
                    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
                }
                return splitStr.join(' ');
            } else {
                return str;
            }
        },
        downloadLocationPerformanceDetails() {
            if(this.dashboardTab == 'audit' && this.graphFilterBy == 'location') {
                this.downloadAuditLocationReport();
            } else if(this.dashboardTab == 'audit' && this.graphFilterBy == 'user') {
                this.downloadAuditUserReport();
            } else if(this.dashboardTab == 'other' && this.graphFilterBy == 'location') {
                this.downloadTaskLocationReport();
            } else if(this.dashboardTab == 'other' && this.graphFilterBy == 'user') {
                this.downloadTaskUserReport();
            }
        },
        downloadAuditLocationReport() {
            let data = this.tableData.map(el => {
                let temp = {};
                temp['Location Id'] = el.store_id ? el.store_id : '';
                temp['Location'] = el.name ? this.titleCase(el.name) : '';
                temp['Region'] = el.region_name ? this.titleCase(el.region_name) : '';
                temp['Area Lead'] = el.subregion_name ? this.titleCase(el.subregion_name) : '';
                // temp['Grade'] = el.grade ? el.grade : '';
                temp['Points Available'] = el.total_yes_no_points ? el.total_yes_no_points : 0;
                temp['Points Achieved'] = el.total_yes_no_points_achieved ? el.total_yes_no_points_achieved : 0;
                temp['Score %'] = el.yes_no_points_percentage ? `${el.yes_no_points_percentage}%` : '0%';
                temp['Completion %'] = el.completion_rate ? `${el.completion_rate}%` : '0%';
                return temp;
            });
            let fileName = `Audit_Performance_Report_By_Location_From_${this.fromDate}_To_${this.toDate}_${this.intermediateCategoryName}`;
            const exportType = exportFromJSON.types.csv;
            exportFromJSON({ data, fileName, exportType });
        },
        downloadAuditUserReport() {
            let data = this.tableData.map(el => {
                let temp = {};
                temp['Location Id'] = el.store_id ? el.store_id : '';
                temp['Location'] = el.outlet_name ? this.titleCase(el.outlet_name) : '';
                temp['Employee Id'] = el.emp_id ? el.emp_id : '';
                temp['Employee'] = el.name ? this.titleCase(el.name) : '';
                temp['Designation'] = el.designation ? this.titleCase(el.designation) : '';
                temp['Region'] = el.region_name ? this.titleCase(el.region_name) : '';
                temp['Area Lead'] = el.subregion_name ? this.titleCase(el.subregion_name) : '';
                temp['Points Available'] = el.total_yes_no_points ? el.total_yes_no_points : 0;
                temp['Points Achieved'] = el.total_yes_no_points_achieved ? el.total_yes_no_points_achieved : 0;
                temp['Score %'] = el.yes_no_points_percentage ? `${el.yes_no_points_percentage}%` : '0%';
                temp['Completion %'] = el.completion_rate ? `${el.completion_rate}%` : '0%';
                return temp;
            });
            let fileName = `Audit_Performance_Report_By_User_From_${this.fromDate}_To_${this.toDate}_${this.intermediateCategoryName}`;
            const exportType = exportFromJSON.types.csv;
            exportFromJSON({ data, fileName, exportType });
        },
        downloadTaskLocationReport() {
            let data = this.tableData.map(el => {
                let temp = {};
                temp['Location Id'] = el.store_id ? el.store_id : '';
                temp['Location'] = el.name ? this.titleCase(el.name) : '';
                temp['Region'] = el.region_name ? this.titleCase(el.region_name) : '';
                temp['Area Lead'] = el.subregion_name ? this.titleCase(el.subregion_name) : '';
                temp['Total Tasks'] = el.total ? el.total : 0;
                temp['Completed'] = el.completed ? el.completed : 0;
                temp['Incomplete'] = el.total ? (el.total - el.completed) : 0;
                temp['Completion %'] = el.completion_rate ? `${el.completion_rate}%` : '0%';
                return temp;
            });
            let fileName = `Task_Performance_Report_By_Location_From_${this.fromDate}_To_${this.toDate}_${this.intermediateCategoryName}`;
            const exportType = exportFromJSON.types.csv;
            exportFromJSON({ data, fileName, exportType });
        },
        downloadTaskUserReport() {
            let data = this.tableData.map(el => {
                let temp = {};
                temp['Location Id'] = el.store_id ? el.store_id : '';
                temp['Location'] = el.outlet_name ? this.titleCase(el.outlet_name) : '';
                temp['Employee Id'] = el.store_id ? el.store_id : '';
                temp['Employee'] = el.name ? this.titleCase(el.name) : '';
                temp['Designation'] = el.designation ? this.titleCase(el.designation) : '';
                temp['Region'] = el.region_name ? this.titleCase(el.region_name) : '';
                temp['Area Lead'] = el.subregion_name ? this.titleCase(el.subregion_name) : '';
                temp['Total Tasks'] = el.total ? el.total : 0;
                temp['Completed'] = el.completed ? el.completed : 0;
                temp['Incomplete'] = el.total ? (el.total - el.completed) : 0;
                temp['Completion %'] = el.completion_rate ? `${el.completion_rate}%` : '0%';
                return temp;
            });
            let fileName = `Task_Performance_Report_By_User_From_${this.fromDate}_To_${this.toDate}_${this.intermediateCategoryName}`;
            const exportType = exportFromJSON.types.csv;
            exportFromJSON({ data, fileName, exportType });
        },
        getTaskCategoryData(basics, name) {
            EventBus.$emit('getTaskCategoryData', {
                basics: basics,
                name: name
            });
        },
        distinct(value, index, self) {
            return self.indexOf(value) === index;
        },
        selectAllAuditReportsRegions() {
            this.selected_region_filter_for_task = this.filtered_list.map(el => el.region_name).filter((value, index, self) => this.distinct(value, index, self));
        },
        resetSelectedAuditReportsRegions() {
            this.selected_region_filter_for_task = [];
        },
        selectAllAuditReportsSubRegions() {
            this.selected_sub_region_filter_for_task = this.filtered_list.map(el => el.subregion_name).filter((value, index, self) => this.distinct(value, index, self));
        },
        resetSelectedAuditReportsSubRegions() {
            this.selected_sub_region_filter_for_task = [];
        }
    }
}
</script>

<style lang="scss">
.customClass.location-details {
    background: #fff;
}
.content-wrapper {
		height: 500px;
    min-width: 991px;
    overflow-x: auto;
}
.content-body {
	height: 500px;
}
</style>
